import { render, staticRenderFns } from "./TheModalInformeCirugia.vue?vue&type=template&id=6a39e4fe&scoped=true&"
import script from "./TheModalInformeCirugia.vue?vue&type=script&lang=js&"
export * from "./TheModalInformeCirugia.vue?vue&type=script&lang=js&"
import style0 from "./TheModalInformeCirugia.vue?vue&type=style&index=0&id=6a39e4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39e4fe",
  null
  
)

export default component.exports